<template>
  <div :class="className" :style="{ height: height, width: width, zoom: barzoom }" />
</template>

<script>
import * as echarts from 'echarts';
import { iswindows } from '@/utils/utils';
require('echarts/theme/macarons'); // echarts theme
// import { debounce } from '@/utils'

export default {
  computed: {
    barzoom() {
      let zoom = window.devicePixelRatio;
      // console.log(zoom)
      // return iswindows() ? zoom : 1;
      return 1;
    },
  },
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '420px',
    },
    bottom: {
      type: String,
      default: '20px',
    },
    legendData: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    pieTitle: {
      type: String,
      default: '',
    },
    colorList: {
      type: Array,
      default: () => {
        return ['#00FFFF', '#00FF00', '#FFFF00', '#FF8C00', '#FF0000', '#FE8463'];
      },
    },
  },
  watch: {
    series: {
      deep: true,
      // immediate: true,
      handler(newvalue, oldvalue) {
        if (newvalue) {
          this.initChart();
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    this.__resizeHandler = this._.debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener('resize', this.__resizeHandler);
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener('resize', this.__resizeHandler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      let that = this;
      this.chart = echarts.init(this.$el, 'macarons');

      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff', //提示框浮层的背景颜色。
          formatter: function (params) {
            if (that.type == 'staffPresent') {
              return params.data.name + ':' + params.data.value + '人' + params.data.datas;
            }
            return params.data.name + ':' + params.data.value + '人';
          },
        },
        title: {
          text: this.pieTitle,
          subtext: '',
          left: 'center',
        },
        legend: {
          width: '160px',
          left: 'center',
          bottom: '30px',
          padding: 1,
          itemGap: 8,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: '#666',
            fontSize: '10px',
            fontFamily: 'PingFangSC-Regular, PingFang SC',
          },
        },
        calculable: true,
        series: [
          {
            type: 'pie',
            center: ['50%', that.type == 'staffPresent' ? '200px' : '170px'],
            radius: '60%',
            data: this.series,
            animationEasing: 'cubicInOut',
            animationDuration: 2600,
            itemStyle: {
              normal: {
                color: function (params) {
                  //自定义颜色
                  var colorList = that.colorList;
                  return colorList[params.dataIndex];
                },
              },
            },
            label: {
              lineHeight:16,
              formatter: function (params) {
                if (that.type == 'staffPresent') {
                  return that.breakline(params.data.value + '人' + params.data.datas) ;
                }
                return that.breakline(params.data.name + ':' + params.data.value + '人')  ;
              },
            },
          },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      });
    },
    breakline(value) {
      var strs = value.split(''); //字符串数组
      var str = '';
      for (var i = 0, s; (s = strs[i++]); ) {
        //遍历字符串数组
        str += s;
        if (!(i % 16)) str += '\n'; //按需要求余
      }
      return str;
    },
  },
};
</script>
